import { render, staticRenderFns } from "./home5.vue?vue&type=template&id=65ecc976&"
import script from "./home5.vue?vue&type=script&lang=js&"
export * from "./home5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports